const CODE_SPAN_OR_FENCE = /(```[\s\S]*?```|`[^`\n]*`)/g;

const normalizeStrongEmphasis = (content: string): string =>
	content.replace(/\*\*([^\n]*?)\*\*/g, (match, inner: string) => {
		const normalizedInner = inner.trim();
		return normalizedInner ? `**${normalizedInner}**` : match;
	});

/**
 * Repairs the whitespace mistakes language models occasionally put immediately
 * inside strong-emphasis delimiters. Code spans and fenced code are left intact.
 */
export const normalizeFlowyMarkdown = (content: string): string =>
	content
		.split(CODE_SPAN_OR_FENCE)
		.map((part, index) => (index % 2 === 0 ? normalizeStrongEmphasis(part) : part))
		.join('');
